import axios, { AxiosError } from "axios";
import ApiConstants from "../../../api-constants";
import { useQuery } from "react-query";
import Constants from "../../../constants";
import { Participant } from "../../../Types/Participant";
import useCompetitionLeaderboard from "./useCompetitionLeaderboard";
import { HandicapCategory } from "../../../Types/HandicapCategory";

const fetchCompetitionHandicapCategories = async (competitionId: string) => {
  const res = await axios.get(ApiConstants.competitionHandicapCategories, {
    headers: {
      Authorization: ApiConstants.authToken,
    },
    params: {
      competitionId,
      tenantId: 1,
    },
  });

  if (res.status === 200) {
    return res.data.results ?? [];
  } else {
    throw new Error(`Unexpected status code: ${res.status}`);
  }
};

function useCompetitionHandicapCategories(competitionId: string) {
  const {
    data: handicapCategories = [],
    error,
    isLoading,
  } = useQuery<HandicapCategory[], AxiosError>(
    ["competitionHandicapCategories", competitionId],
    () => fetchCompetitionHandicapCategories(competitionId),
    {
      enabled: Boolean(competitionId !== null), // Fetch only if conditions are met
      refetchInterval: Constants.refreshTime, // Refetch every 20 seconds
      refetchOnWindowFocus: false, // Optional: Avoid refetching on window focus
      initialData: [], // Optional: Return an empty array until data is fetched
      retry: false, // Do not retry if an error occurs
    }
  );

  return { handicapCategories, isLoading, error };
}

export default useCompetitionHandicapCategories;
